var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, BLACK_700, Card, getTestId, InView, isLastItem, Typography, useBreakpoint } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { FlatList, View } from 'react-native';
import { getQuickFilterWidgetStyles } from './QuickFilterWidgetStyles';
import { initiallySingleSelectFromList, updateListItemAndScrollItem } from './QuickFilterWidgetUtils';
export var QuickFilterWidgetComponent = props => {
  var header = props.header,
    _props$type = props.type,
    type = _props$type === void 0 ? 'single' : _props$type,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    style = props.style,
    id = props.id,
    onUserAction = props.onUserAction,
    onPress = props.onPress,
    onHeaderPress = props.onHeaderPress,
    onClear = props.onClear,
    showWithCardInDesktop = props.showWithCardInDesktop,
    _props$showHeaderPref = props.showHeaderPrefixIcon,
    showHeaderPrefixIcon = _props$showHeaderPref === void 0 ? false : _props$showHeaderPref,
    _props$showHeaderPost = props.showHeaderPostfixIcon,
    showHeaderPostfixIcon = _props$showHeaderPost === void 0 ? false : _props$showHeaderPost,
    iconProps = props.iconProps,
    testID = props.testID,
    onItemVisibleMetaData = props.onItemVisibleMetaData,
    inViewTriggerOnce = props.inViewTriggerOnce,
    _props$showFilterSect = props.showFilterSectionInCard,
    showFilterSectionInCard = _props$showFilterSect === void 0 ? false : _props$showFilterSect,
    _props$shouldAllowTog = props.shouldAllowToggle,
    shouldAllowToggle = _props$shouldAllowTog === void 0 ? true : _props$shouldAllowTog,
    _props$sendManualImpr = props.sendManualImpression,
    sendManualImpression = _props$sendManualImpr === void 0 ? false : _props$sendManualImpr,
    restProps = __rest(props, ["header", "type", "list", "style", "id", "onUserAction", "onPress", "onHeaderPress", "onClear", "showWithCardInDesktop", "showHeaderPrefixIcon", "showHeaderPostfixIcon", "iconProps", "testID", "onItemVisibleMetaData", "inViewTriggerOnce", "showFilterSectionInCard", "shouldAllowToggle", "sendManualImpression"]);
  var _a = header || {},
    _a$text = _a.text,
    headerText = _a$text === void 0 ? 'FILTER' : _a$text,
    headerStyle = _a.style,
    restHeaderProps = __rest(_a, ["text", "style"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var showWithCard = isLargeScreen && showWithCardInDesktop || showFilterSectionInCard;
  var quickFilterWidgetStyles = getQuickFilterWidgetStyles(showWithCard);
  var listRef = useRef();
  var _useState = useState(list),
    filterList = _useState[0],
    setFilterList = _useState[1];
  var Wrapper = showWithCard ? Card : View;
  useEffect(() => {
    if (list != filterList) {
      setFilterList(list);
    }
  }, [list]);
  useEffect(() => {
    initiallySingleSelectFromList(type, filterList, listRef, setFilterList);
  }, [type]);
  var onFilterItemPress = _ref => {
    var item = _ref.item,
      index = _ref.index;
    var updatedList = updateListItemAndScrollItem({
      item,
      index
    }, filterList, listRef, type, shouldAllowToggle);
    setFilterList([...updatedList]);
    var selectedFilterList = updatedList.filter(_item => _item.isSelected);
    if (selectedFilterList.length <= 0) {
      onClear && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onClear)));
    }
    var onPressAction = item.onPress || onPress;
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onPressAction), Object.assign({
      filterList: selectedFilterList,
      currentItem: item,
      currentIndex: index
    }, props));
  };
  var renderItem = _ref2 => {
    var item = _ref2.item,
      index = _ref2.index;
    var _a = item || {},
      label = _a.label,
      isSelected = _a.isSelected,
      restItemProps = __rest(_a, ["label", "isSelected"]);
    sendManualImpression && onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onItemVisibleMetaData), Object.assign({
      index
    }, item)));
    return _jsx(InView, Object.assign({
      triggerOnce: inViewTriggerOnce,
      onChange: inView => {
        inView && onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onItemVisibleMetaData), Object.assign({
          index
        }, item)));
      }
    }, {
      children: _jsx(Badge, Object.assign({
        size: "md",
        style: [!isLastItem(filterList, index) && quickFilterWidgetStyles.itemRightSpace, quickFilterWidgetStyles.itemBottomSpace]
      }, restItemProps, {
        label: label,
        isSelected: isSelected,
        onPress: () => {
          onFilterItemPress({
            item,
            index
          });
        },
        type: type
      }, getTestId(testID + '_singleItem', index.toString())), "single_item_" + index)
    }));
  };
  return _jsxs(Wrapper, Object.assign({
    style: [quickFilterWidgetStyles.root, style],
    paddingToken: "SPACING_20"
  }, restProps, getTestId(testID), {
    children: [showHeaderPrefixIcon || showHeaderPostfixIcon ? _jsx(Badge, Object.assign({
      label: headerText,
      size: "md",
      showPrefixIcon: showHeaderPrefixIcon,
      showPostfixIcon: showHeaderPostfixIcon,
      onPress: () => onHeaderPress && onUserAction(Object.assign({
        id
      }, onHeaderPress))
    }, getTestId(testID, 'badge'), iconProps)) : _jsx(Typography, Object.assign({
      text: headerText,
      color: BLACK_700,
      style: [quickFilterWidgetStyles.header, headerStyle],
      type: "button-text-primary-md"
    }, getTestId(testID, 'headerText'), restHeaderProps)), !showWithCard ? _jsx(FlatList, Object.assign({
      ref: listRef,
      data: filterList,
      renderItem: renderItem,
      keyboardShouldPersistTaps: "handled",
      showsHorizontalScrollIndicator: false,
      horizontal: true,
      keyExtractor: (_, index) => "single_item_" + index,
      style: quickFilterWidgetStyles.filterListContainer
    }, getTestId(testID, 'filterListContainer'), {
      onScrollToIndexFailed: () => {}
    })) : _jsx(View, Object.assign({}, getTestId(testID + '_showWithCard', 'filterListContainer'), {
      style: quickFilterWidgetStyles.filterListContainer
    }, {
      children: filterList.map((item, index) => renderItem({
        item,
        index
      }))
    }))]
  }));
};
QuickFilterWidgetComponent.genericRendererKey = 'AirQuickFilterWidget';